/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type RewardType = typeof RewardType[keyof typeof RewardType];


export const RewardType = {
  Nothing: 'Nothing',
  Points: 'Points',
  Flames: 'Flames',
} as const;
